import { Box, Grid, IconButton, makeStyles, TextField, Tooltip, Typography } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import * as React from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaInfoCircle } from "react-icons/fa";
import InputMask from "react-input-mask";
import GridInputRow from "../../form-grids/GridInputRow";
import { IconLabelSwitch } from "../../iconSwitch/IconLabelSwitch";
import "./InputFieldStyle.scss";

const InputField = React.forwardRef((props, ref) => {
    const { t } = useTranslation();

    //Input Type Number Filter
    const handleChange = (event) => {
        const { data } = event.nativeEvent;
        if (!!data) {
            if (props.type === "number") {
                const reg = new RegExp("^[0-9]+$");
                if (!reg.test(data)) return;
            }
        }
        props.onChange(event);
    };

    return (
        <FormControl fullWidth ref={ref}>
            <Controller
                as={
                    <div>
                        <div>
                            <>
                                <GridInputRow>
                                    <Grid item xs={10}>
                                        {props.iconLabelSwitch ? (
                                            props.iconLabelSwitch
                                        ) : props.hasTooltip ? (
                                            <Box
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                }}
                                            >
                                                <IconLabelSwitch
                                                    style={props.error && !!!props.value && props.disabled
                                                        ? { color: "red" }
                                                        : null
                                                    }
                                                    labelName={(<>
                                                        {props.label ? props.label : t(props.name)}
                                                        <Tooltip
                                                            placement="right"
                                                            title={
                                                                <Typography>
                                                                    {props.labelTooltip
                                                                        ? props.labelTooltip
                                                                        : ""}
                                                                </Typography>
                                                            }
                                                            style={{
                                                                padding: 0,
                                                                width: "20px",
                                                                height: "20px",
                                                            }}
                                                        >
                                                            <IconButton>
                                                                <FaInfoCircle color={getComputedStyle(document.documentElement).getPropertyValue('--primary')} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                    )} />
                                            </Box>
                                        ) : (
                                            <IconLabelSwitch
                                                style={props.error && !!!props.value && props.disabled
                                                    ? { color: "red" }
                                                    : null
                                                }
                                                labelName={props.label ? props.label : t(props.name)}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item xs={1}>
                                        {props.tooltip && props.tooltip}
                                    </Grid>
                                </GridInputRow>
                            </>
                        </div>
                        <div>
                            {!props.mask ? (
                                <TextField
                                    size={process.env.REACT_APP_TEXT_FIELD_SIZE}
                                    variant="outlined"
                                    fullWidth
                                    {...props.params}
                                    onKeyPress={props.onKeyPress}
                                    name={props.name}
                                    onChange={(event) => handleChange(event)}
                                    value={props.value}
                                    inputProps={{
                                        ...props.inputProps,
                                        className: props.inputProps?.className ? props.inputProps?.className : "defaultInput"
                                    }}
                                    type={props.type}
                                    error={props.customError || (props.error && !props.value)}
                                    onBlur={props.onBlur}
                                    multiline={props.multiline}
                                    className={props.className ? props.className : "defaultInput"}
                                    rows={props.rows}
                                    disabled={props.disabled}
                                    rowsMax={props.rowsMax}
                                    placeholder={props.placeholder}
                                    autoFocus={props.autoFocus}
                                />
                            ) : (
                                <InputMask
                                    mask={props.mask}
                                    previousState={true}
                                    maskChar={null}
                                    value={props.value}
                                    onChange={(event) => handleChange(event)}
                                    placeholder={props.placeholder}
                                    name={props.name}
                                    size={process.env.REACT_APP_TEXT_FIELD_SIZE}
                                    variant="outlined"
                                    fullWidth
                                    {...props.params}
                                    inputProps={{
                                        ...props.inputProps,
                                        className: props.inputProps?.className ? props.inputProps?.className : "defaultInput"
                                    }}
                                    type={props.type}
                                    error={props.customError || (props.error && !!!props.value)}
                                    onBlur={props.onBlur}
                                    multiline={props.multiline}
                                    className={props.className ? props.className : "defaultInput"}
                                    rows={props.rows}
                                    disabled={props.disabled}
                                    rowsMax={props.rowsMax}
                                >
                                    {(inputProps) => <TextField {...inputProps} />}
                                </InputMask>
                            )}
                        </div>
                    </div>
                }
                name={props.name}
                control={props.control}
                defaultValue={props.defaultValue}
            />
        </FormControl>
    );
});

export default InputField;
